import { useMemo, useState } from "react";
import Layout from "../shared/Layout";
import PageHeader from "../shared/PageHeader";
import language from "../../variables/language";
import FilterBar from "../../components/settings/FilterBar";
import useConversationProgressList from "./useConversationProgressList";
import { filterProgress, sortProgress } from "./filterAndSortProgress";
import ConversationProgressRow from "./ConversationProgressRow";
import "../../css/conversations.css";

const STATUS_OPTIONS = [
    { id: "all", name: "Всі" },
    { id: "finished", name: "Завершено" },
    { id: "pending", name: "В процесі" },
];

const SORT_OPTIONS = [
    { id: "newest", name: "Спочатку нові" },
    { id: "oldest", name: "Спочатку старі" },
];

export default function IndexConversationProgress() {
    const { progresses, conversationTypes } = useConversationProgressList();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("all");
    const [typeId, setTypeId] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [sort, setSort] = useState("newest");

    const visibleProgresses = useMemo(() => {
        const filtered = filterProgress(progresses, { search, status, typeId, dateFrom, dateTo });
        return sortProgress(filtered, sort);
    }, [progresses, search, status, typeId, dateFrom, dateTo, sort]);

    const stats = useMemo(() => {
        const finished = visibleProgresses.filter((p) => p.isFinished === 1).length;
        const uniqueConversations = new Set(visibleProgresses.map((p) => p.conversationId?.id).filter(Boolean)).size;
        return {
            total: visibleProgresses.length,
            finished,
            pending: visibleProgresses.length - finished,
            uniqueConversations,
        };
    }, [visibleProgresses]);

    return (
        <Layout>
            <PageHeader name={`${language[language.lang]["Bot"]} - ${language[language.lang]["conversationprogress"]}`}>
                <FilterBar
                    search={{ value: search, onChange: setSearch, placeholder: "Пошук за тестом чи учасником..." }}
                    filters={[
                        { key: "status", label: "Статус", value: status, onChange: setStatus, options: STATUS_OPTIONS },
                        { key: "typeId", label: "Тип тесту", value: typeId, onChange: setTypeId, options: conversationTypes, numeric: true },
                        { key: "dateFrom", type: "date", label: "Від", value: dateFrom, onChange: setDateFrom },
                        { key: "dateTo", type: "date", label: "До", value: dateTo, onChange: setDateTo },
                    ]}
                    sort={{ value: sort, onChange: setSort, options: SORT_OPTIONS }}
                />
            </PageHeader>
            <main className="main-block">
                <div className="main-content txt-c conv-progress-page">
                    <div className="conv-progress-stats-row">
                        <div className="conv-progress-stats">
                            <div className="conv-progress-stat">
                                <span className="conv-progress-stat-value">{stats.total}</span>
                                <span className="conv-progress-stat-label">Всього проходжень</span>
                            </div>
                            <div className="conv-progress-stat">
                                <span className="conv-progress-stat-value">{stats.finished}</span>
                                <span className="conv-progress-stat-label">Завершено</span>
                            </div>
                            <div className="conv-progress-stat">
                                <span className="conv-progress-stat-value">{stats.pending}</span>
                                <span className="conv-progress-stat-label">В процесі</span>
                            </div>
                            <div className="conv-progress-stat">
                                <span className="conv-progress-stat-value">{stats.uniqueConversations}</span>
                                <span className="conv-progress-stat-label">Різних тестів</span>
                            </div>
                        </div>

                        <p className="conv-progress-list-count">Знайдено: {visibleProgresses.length}</p>
                    </div>

                    <ul className="conv-participants-list conv-progress-list">
                        {visibleProgresses.map((progress) => (
                            <ConversationProgressRow key={progress.id} progress={progress} />
                        ))}
                    </ul>
                </div>
            </main>
        </Layout>
    );
}
